import { HimuraInject } from 'himura';
import { DataDelegate } from '../data.delegate';
import * as T_T from 'cryface';
import { CommonConfig } from '../../../configs/config.common';
import { AxiosPromise } from '../../../utils/axios.promise';
import { News } from '../../../models/news.model';
@HimuraInject.NamedService('NewsListDelegate')
export class NewsListDelegate extends DataDelegate {
    private commonConfigs: CommonConfig = new CommonConfig();
    constructor() {
        super('NewsListDelegate');
    }

    public async getNewsList(type: string, pageNo: number): Promise<any> {
        const apiHost: string = this.commonConfigs.cmisapiHost;
        const paramBody = {
            ltype: 0,
            pageNum: pageNo,
            pageSize: 5,
            channelName: type.split('_').join(' ')
        };
        // const result = await AxiosPromise.postUrlEncode(`https://api.realjaja.com/new/rifoWebNewsList`, paramBody);
        const result = await AxiosPromise.postUrlEncode(`${apiHost}/new/rifoWebNewsList`, paramBody);
        if (result.data && result.data.data) {
            result.data.data = result.data.data.filter((item: any, index: any, self: any) =>
                index === self.findIndex((t: any) => (t.id === item.id)
            ));
            return result.data;
        } else {
            return {
                data: []
            };
        }
    }
    public async getPopularList(): Promise<any> {
        const apiHost: string = this.commonConfigs.cmisapiHost;
        const paramBody = {
            ltype: 0,
            count: 5,
        };
        // const result = await AxiosPromise.postUrlEncode(`https://api.realjaja.com/new/rifoWebNewsList`, paramBody);
        const result = await AxiosPromise.postUrlEncode(`${apiHost}/new/selectPopularRifoNews`, paramBody);
        if (result.data && result.data.data) {
            result.data.data = result.data.data.filter((item: any, index: any, self: any) =>
                index === self.findIndex((t: any) => (t.id === item.id)
            ));
            return result.data;
        } else {
            return {
                data: []
            };
        }
    }
    public async getNewsDetail(source: string, newsId: string): Promise<any> {
        const apiHost: string = this.commonConfigs.cmisapiHost;
        // const result = await AxiosPromise.get(`https://api.realjaja.com/new/rifoNewsInfo?ltype=0&type=${source}&id=${newsId}`);
        const result = await AxiosPromise.get(`${apiHost}/new/rifoNewsInfo?ltype=0&type=${source}&id=${newsId}`);
        return result.data;
    }
}
